<template>
    <b-modal id="generate-recurring"
        :cancel-title="i18nT(`Cancel`)"
        :ok-title="i18nT(`Generate`)"
        :ok-disabled="!createCount"
        @ok="generateRecurring"
    >

        <b-row class="py-1">
            <b-col class="text-center">
                <h3 class="mb-2">{{i18nT(`Generate Recurring Invoices`)}}</h3>
                <div v-if="createCount">
                    <p class="mb-2" >{{i18nT(`With this action you will be generating new invoices based on the recurring invoices already in your list that have a recurrence date before or at the current date.`)}}</p>
                    <p class="mb-2"><strong>{{createCount>maxCount ? maxCount : createCount}}</strong> {{i18nT(`The new invoices will be created in`)}}<b-badge class="mx-1 badge-pill">{{i18nT(`DRAFT`)}}</b-badge>{{i18nT(`mode`)}}.</p>
                    <p v-if="createCount > maxCount" class="mb-2 text-danger"><strong>{{i18nT(`You have a total of `)+' '+createCount+' '+i18nT(`that need to be created.`)+' '+i18nT(`You will need to run this action again to generate the remaining.`)}}</strong></p>
                    <p class="mb-2">{{i18nT(`You will need to open and edit each invoice to confirm its contents and give it a number, before you can send it out.`)}}</p>
                    <p class="mb-2"><font-awesome-icon :icon="['fas', 'triangle-exclamation']"></font-awesome-icon> {{i18nT(`If you delete the draft copies before saving them you will not be able to regenerate the same recurring invoice again and will have to edit the last available recurring invoice again.`)}}</p>
                    <p class="mb-0">{{i18nT(`Do you wish to proceed?`)}}</p>
                </div>
                <p class="mb-2" v-else>{{i18nT(`You have no recurring invoices that will generate additional new invoices by today's date`)}}.</p>
            </b-col>
        </b-row>

    </b-modal>
</template>


<script>
import {
    BModal,
    BRow,
    BCol,
    BBadge,
} from 'bootstrap-vue'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
    components: {
        BModal,
        BRow,
        BCol,
        BBadge
    },
    name: "InvoiceModalRecurring",
    data() {
        return{
            createCount: 0,
            maxCount: 100
        }
    },
    created(){
        this.getRecurringCount();
    },
    methods: {
        getRecurringCount(){
            this.$http.get(`invoices/createRepeatInvoices?count=1`)
                .then((resp) => {
                    this.createCount = resp.data.data.recurring_count;
                }).catch(err => {
                    console.log(this.errorMessage(err));
                })
        },
        generateRecurring(){
            this.$http
                .get(`invoices/createRepeatInvoices`)
                .then(() => {
                    this.$emit('generated');
                    this.$bvModal.hide('generate-recurring');
                }).catch(err => {
                this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                        title: this.errorMessage(err),
                        icon: 'AlertTriangleIcon',
                        variant: 'danger'
                    }
                })
            })
        }
    }
}
</script>

<style>

</style>
